import { useSuspenseQuery } from '@tanstack/react-query';
import type { QueryKey } from '@tanstack/react-query';
import type { QueryConfig } from 'lib/react-query';
import type { Project, WeekDays } from './types';

export interface WeekdayEntry {
  id: number;
  name: WeekDays;
}

export const getWeekDays = async (signal?: AbortSignal): Promise<WeekdayEntry[]> => {
  return Promise.resolve([
    {
      id: 1,
      name: 'Monday',
    },
    {
      id: 2,
      name: 'Tuesday',
    },
    {
      id: 3,
      name: 'Wednesday',
    },
    {
      id: 4,
      name: 'Thursday',
    },
    {
      id: 5,
      name: 'Friday',
    },
    {
      id: 6,
      name: 'Saturday',
    },
    {
      id: 7,
      name: 'Sunday',
    },
  ]);
};

interface UseWeekDaysOptions<TData> {
  config?: QueryConfig<typeof getWeekDays, TData>;
}

export const useWeekDays = <TData = Project[]>({ config }: UseWeekDaysOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getWeekDays(signal),
    queryKey: ['weekdays'] as QueryKey,
  });
};
